module.exports = __webpack_public_path__ + "media/promo/advent/images/logo-1-98d89543a930e3458dfe084d870801ab.png";